<!--
时间
-->
<template>
  <div class="CatWebPcIndex">
    <div class="statistics">
      <div class="unfinished-work">
        <p class="p-left"></p>
        <p class="p-right">
          <i class="nums">{{countNum.countNotFinish ? countNum.countNotFinish : 0}}</i>
          <el-tooltip :disabled="showTitle" offect="light" :content="$t('jobManagementV2.incomplete')" placement="top">
            <i class="words" @mouseover="changeshowTitle($event)">{{$t('jobManagementV2.incomplete')}}</i>
          </el-tooltip>
        </p>
      </div>
      <span></span>
      <div class="work-done">
        <p class="p-left"></p>
        <p class="p-right">
          <i class="nums"> {{ countNum.countFinish ? countNum.countFinish : 0 }}</i>
          <el-tooltip :disabled="showTitle" offect="light" :content="$t('project.completed')" placement="top">
            <i class="words" @mouseover="changeshowTitle($event)">{{$t('project.completed')}}</i>
          </el-tooltip>
        </p>
      </div>
      <span></span>
      <div class="lateCompletion-work">
        <p class="p-left"></p>
        <p class="p-right">

          <i class="nums"> {{countNum.countFinishedOverdue ? countNum.countFinishedOverdue : 0}}</i>
          <el-tooltip :disabled="showTitle" offect="light" :content="$t('projectDetailsV2.overdueComplete')" placement="top">
            <i class="words" @mouseover="changeshowTitle($event)">{{$t('projectDetailsV2.overdueComplete')}}</i>
          </el-tooltip>
        </p>
      </div>
      <span></span>
      <div class="overdue">
        <p class="p-left"></p>
        <p class="p-right">

          <i class="nums"> {{ countNum.countOverdue ? countNum.countOverdue : 0 }}</i>
          <el-tooltip :disabled="showTitle" offect="light" :content="$t('projectDetailsV2.overdue')" placement="top">
            <i class="words" @mouseover="changeshowTitle($event)">{{$t('projectDetailsV2.overdue')}}</i>
          </el-tooltip>
        </p>
      </div>
    </div>

    <div class="table-card">
      <el-table v-if="type == 1" :data="tableData" border style="width: 100%" ref="tableList" height="calc(100% - 50px)" :header-cell-style="{
        height:'50px',
        padding:0,
       background: '#F3F7FE',
    color:' #566087',
    'font-weight': 'bold',
        }"  :cell-style="{
          padding:0,
          height:'48px'
        }" @sort-change="sortChange">
        <el-table-column :resizable='false' :label="$t('projectV2.index')" width="57" align="center">
          <template slot-scope="scope">
            <span v-text="getIndex(scope.$index)"> </span>
          </template>
        </el-table-column>
        <el-table-column :resizable='false' :label="
            type === 2
              ? $t('jobManagementV2.testName')
              : $t('jobManagementV2.jobName')
          " align="center" :show-overflow-tooltip="true" prop="projectName">
          <template slot-scope="scope">
            <span class="mytestdetail" @click="checkJob(scope.row)">{{scope.row.projectName}}</span>
          </template>
        </el-table-column>
        <el-table-column :resizable='false' :label="$t('projectV2.langDesc')" :show-overflow-tooltip="true" align="center" prop="langDesc">
          <template slot-scope="{ row }">
            <template v-if="$i18n.locale === 'zh'">{{row.langDesc.split('>')[0]}} —
              {{row.langDesc.split('>')[1]}}</template>
            <template v-else>{{$langCase[row.sourceLang]}} —
              {{$langCase[row.targetLang]}}</template>
          </template>
        </el-table-column>

        <el-table-column  :resizable='false' :label="$t('projectV2.domain')" align="center" prop="domainName">
          <template slot-scope="{ row }">
            {{
              $i18n.locale === "zh"
                ? row.domainName
                : $domainCase[row.domainCode]
            }}
          </template>
        </el-table-column>

        <el-table-column :resizable='false' :label="$t('projectV2.creator')" :show-overflow-tooltip="true" align="center" prop="pmName"></el-table-column>
        <el-table-column  :resizable='false' :label="$t('projectV2.limitTime')" align="center" sortable="custom" :show-overflow-tooltip="true" prop="limitTime"></el-table-column>
        <el-table-column  :resizable='false' :label="$t('jobManagementV2.finishProgress')" align="center" min-width="150" prop="progress">
          <template slot-scope="scoped">
            <el-progress :percentage="scoped.row.progress"></el-progress>
          </template>
        </el-table-column>
        <el-table-column :resizable='false' :label="$t('projectV2.state')" align="center" width="190" prop="finish">
          <template slot-scope="scoped">
            <div v-if="scoped.row.finish == 0" class="incompleted">

              <span>{{
              $t("jobManagementV2.notStarted")
            }}</span>
            </div>
            <div v-if="scoped.row.finish == 1" class="completed">

              <span>{{
              $t("jobManagementV2.completed")
            }}</span>
            </div>
            <div v-if="scoped.row.finish == 2" class="underway">

              <span>{{
              $t("jobManagementV2.ongoing")
            }}</span>
            </div>
            <div v-if="scoped.row.finish == 3" class="overdues">

              <span>{{
              $t("jobManagementV2.overdue")
            }}</span>
            </div>
            <div v-if="scoped.row.finish == 4" class="overdueComplete">
              <span>{{
              $t("jobManagementV2.overdueComplete")
            }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column :resizable='false' :label="$t('projectV2.operation')" width="117" align="center">
          <template slot-scope="scoped">
            <div class="operation">
              <el-tooltip class="item" effect="dark" :content="$t('projectV2.check')" placement="top">
                <span class="check" @click="checkJob(scoped.row)"></span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-table v-if="type == 2" height="calc(100% - 50px)" :data="tableData" border style="width: 100%" ref="tableList" :header-cell-style="{
        height:'50px',
        padding:0,
       background: '#F3F7FE',
    color:' #566087',
    'font-weight': 'bold',
        }"  :cell-style="{
          padding:0,
          height:'48px'
        }" @sort-change="sortChange">
        <el-table-column :resizable='false' :label="$t('projectV2.index')" width="57" align="center">
          <template slot-scope="scope">
            <span v-text="getIndex(scope.$index)"> </span>
          </template>
        </el-table-column>
        <el-table-column  :resizable='false' :label="
            type === 2
              ? $t('jobManagementV2.testName')
              : $t('jobManagementV2.jobName')
          " align="center" :show-overflow-tooltip="true" prop="projectName">
          <template slot-scope="scope">
            <span class="mytestdetail" @click="checkJob(scope.row)">{{scope.row.projectName}}</span>
          </template>
        </el-table-column>
        <el-table-column :resizable='false' :label="$t('projectV2.langDesc')" :show-overflow-tooltip="true" align="center" prop="langDesc">
          <template slot-scope="{ row }">
            <template v-if="$i18n.locale === 'zh'">{{row.langDesc.split('>')[0]}} —
              {{row.langDesc.split('>')[1]}}</template>
            <template v-else>{{$langCase[row.sourceLang]}} —
              {{$langCase[row.targetLang]}}</template>
          </template>
        </el-table-column>

        <el-table-column  :resizable='false' :label="$t('projectV2.domain')" align="center" prop="domainName">
          <template slot-scope="{ row }">
            {{
              $i18n.locale === "zh"
                ? row.domainName
                : $domainCase[row.domainCode]
            }}
          </template>
        </el-table-column>

        <el-table-column :resizable='false' :label="$t('projectV2.creator')" :show-overflow-tooltip="true" align="center" prop="pmName"></el-table-column>
        <el-table-column :resizable='false' :label="$t('jobManagementV2.startTime')" :show-overflow-tooltip="true" align="center" sortable="custom" prop="startTime"></el-table-column>
        <el-table-column :resizable='false' :label="$t('projectV2.limitTime')" align="center" sortable="custom" :show-overflow-tooltip="true" prop="limitTime"></el-table-column>
        <el-table-column  :resizable='false' :label="$t('jobManagementV2.finishProgress')" align="center" min-width="150" prop="progress">
          <template slot-scope="scoped">
            <el-progress :percentage="scoped.row.progress"></el-progress>
          </template>
        </el-table-column>
        <el-table-column :resizable='false' :label="$t('projectV2.state')" align="center" prop="finish">
          <template slot-scope="scoped">
            <div v-if="scoped.row.finish == 0" class="incompleted">

              <span>{{
              $t("jobManagementV2.notStarted")
            }}</span>
            </div>
            <div v-if="scoped.row.finish == 1" class="completed">

              <span>{{
              $t("jobManagementV2.completed")
            }}</span>
            </div>
            <div v-if="scoped.row.finish == 2" class="underway">

              <span>{{
              $t("jobManagementV2.ongoing")
            }}</span>
            </div>
            <div v-if="scoped.row.finish == 3" class="overdues">

              <span>{{
              $t("jobManagementV2.overdue")
            }}</span>
            </div>
            <div v-if="scoped.row.finish == 4" class="overdueComplete">

              <span>{{
              $t("jobManagementV2.overdueComplete")
            }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column :resizable='false' :label="$t('projectV2.operation')" align="center">
          <template slot-scope="scoped">
            <div class="operation">
              <el-tooltip class="item" effect="dark" :content="$t('projectV2.check')" placement="top">
                <span class="check" @click="checkJob(scoped.row)"></span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange" :current-page="pageDto.page" :page-size="pageDto.rows" :page-sizes="[10, 20, 30, 40]" layout="prev, pager, next, sizes" :total="tableDataInfo.totalRows">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  countUserFinishWordNum,
  queryPageMyTask,
} from "../../services/jobManagement";

export default {
  name: "CatWebPcIndex",

  data() {
    return {
      type: 1, //1我的作业 2我的测试
      tableDataInfo: {
        totalRows: 0,
        totalPage: 0,
      },
      pageDto: {
        filter: {},
        page: 1,
        rows: 10,
        sort: {},
      },
      tableData: [],
      countNum: {
        countNotFinish: 0,
        countFinish: 0,
      },
      showTitle: true,
    };
  },
  created() {
    if (this.$route.path === "/home/jobManagement/myTask") {
      this.type = 1;
      this.pageDto.page = 1
      // Number(sessionStorage.getItem("myCurrentPageTask")) || 1;
    } else {
      this.pageDto.page = 1
      // Number(sessionStorage.getItem("myCurrentPageTest")) || 1;
      this.type = 2;
    }
    this.queryJob(this.pageDto.page, { create_time: "desc" });
    this.getTotalNum();
  },
  destroyed() {
    // if (this.$route.path === "/home/jobManagement/myTask") {
    //   window.sessionStorage.removeItem("myCurrentPageTask");
    // } else {
    //   window.sessionStorage.removeItem("myCurrentPageTest  ");
    // }
  },
  mounted() {
  },

  methods: {
    changeshowTitle(e) {
      let target = e.target
      let textLength = target.clientWidth
      let containerLength = target.scrollWidth
      if (textLength < containerLength) {
        this.showTitle = false;
      } else {
        this.showTitle = true;
      }
    },
    //列表排序
    sortChange({ column, prop, order }) {
      if (order == "descending") {
        order = "desc";
      } else if (order == "ascending") {
        order = "asc";
      }
      if (order === null) {
        this.queryJob(this.pageDto.page, { create_time: "desc" });
        return;
      }
      switch (prop) {
        case "startTime":
          this.pageDto.sort = { start_time: order };
          this.queryJob(this.pageDto.page, {
            start_time: order,
          });
          break;
        case "limitTime":
          this.pageDto.sort = { limit_time: order };
          this.queryJob(this.pageDto.page, {
            limit_time: order,
          });
          break;
        default:
          break;
      }
    },

    async queryJob(page, sort) {
      if (this.type === 2) {
        this.pageDto.filter.sourceType = 2;
      } else if (this.type === 1) {
        this.pageDto.filter.sourceType = 1;
      }
      this.pageDto.page = page;
      this.pageDto.sort = sort || { create_time: "desc" };
      this.pageDto.filter.companyCode = localStorage.myCompanyCode;
      this.pageDto.filter.platformType = this.$platformType;

      const { list, totalPage, totalRows, success } = await queryPageMyTask(
        this.pageDto
      );
      if (!success) return;
      this.tableData = list;
      this.tableDataInfo.totalPage = totalPage;
      this.tableDataInfo.totalRows = totalRows;
    },
    checkJob(row) {
      let routerName = "";
      if (this.type === 1) {
        routerName = "jobDetails";
      } else {
        routerName = "testDetails";
      }
      this.$router.push({
        name: routerName,
        query: {
          key: this.$Base64.encode(JSON.stringify({
            id: row.projectId,
            userLevel: 2,
            companyCode: row.companyCode,
          })),
        },
      }); //userLevel为2则为学生
    },
    // 统计完成、未完成、逾期总数
    getTotalNum() {
      let params = {
        sourceType: this.type,
      };
      countUserFinishWordNum(params).then(({ result }) => {
        if (result) {
          this.countNum = result;
        }
      });
    },
    // 序号格式化
    getIndex($index) {
      (this.pageDto.page - 1) * this.pageDto.rows + $index + 1;
      if ($index < 9) {
        return "0" + ($index + 1);
      } else {
        return $index + 1;
      }
    },
    // 分页
    handleCurrentChange(val) {
      this.pageDto.page = val;
      this.queryJob(val, this.pageDto.sort);
      if (this.type === 1) {
        sessionStorage.setItem("myCurrentPageTask", val);
      } else {
        sessionStorage.setItem("myCurrentPageTest", val);
      }
    },
    handleSizeChange(val) {
      this.pageDto.rows = val;
      this.queryJob(this.pageDto.page, this.pageDto.sort);
    },
    tableRowClassName({ row }) {
      if (row.finish === 0 && new Date(row.limitTime) < new Date()) {
        return "row-overdue";
      }
    },
  },
  watch: {
    $route: {
      handler() {
        if (this.$route.path === "/home/jobManagement/myTask") {
          this.type = 1;
          this.pageDto.page = 1
          this.pageDto.rows = 10;
          this.pageDto.sort = {}
        } else {
          this.pageDto.rows = 10;
          this.pageDto.page = 1
          this.type = 2;
          this.pageDto.sort = {}
        }
        this.queryJob(this.pageDto.page);
        this.getTotalNum();
      },
      deep: true,
    },
  },
};
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>
